import React from 'react';
import grey from '@material-ui/core/colors/grey';
import { makeStyles } from '@material-ui/core/styles';
import { alpha } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(() => ({
  root: {
    zIndex: 30000,
    left: 0,
    top: 0,
    width: '100vw',
    height: '100vh',
    position: 'fixed',
    backgroundColor: alpha(grey[200], 0.6),
  },
  container: {
    height: '100%',
  },
  circularProgress: {
    position: 'fixed',
    top: 'calc(50% - 45px)',
    left: 'calc(50% - 45px)',
  },
}));

const Loader = () => {
  const classes = useStyles();
  return (
    <Grid className={classes.root}>
      <Grid container justifyContent="center" alignItems="center" className={classes.container}>
        <CircularProgress className={classes.circularProgress} size={90} thickness={1} color="primary" />
      </Grid>
    </Grid>
  );
};

export default Loader;
